import {
  RoleCreate,
  RoleEdit,
  RoleList,
  RolesShow
} from 'pages/configurations/roles';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'roles',
  label: 'Perfis e regras de acesso',
  list: RoleList,
  edit: RoleEdit,
  create: RoleCreate,
  show: RolesShow,
  actions: ['list', 'show', 'edit', 'create', 'delete'],
  parentName: 'configurations'
};

export default generateResources(resource);
